import { render, staticRenderFns } from "./SurveyWriteS1View.vue?vue&type=template&id=be84a3ac"
import script from "./SurveyWriteS1View.ts?vue&type=script&lang=ts&external"
export * from "./SurveyWriteS1View.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports